import { useCallback } from "react";
import { useLocalization } from "@fluent/react";
import { useFeature } from "byzantine/src/dbbl/businessLogic/modules/features";
import { FilterChips, FilterType, FILTER_CONFIG } from "./filterConfig";
import { MultiSelectFilter } from "./common";

const FileImportMethodFilter = ({
  isActive,
  filters,
  handleSetFilter,
  handleSetActive,
  handleToggleFilter,
}: FilterType) => {
  const { l10n } = useLocalization();
  const { featureEnabled } = useFeature();
  const label = l10n.getString(
    FILTER_CONFIG[FilterChips.FILE_IMPORT_METHOD].labelKey,
  );

  const filterByFeatureEnabled = useCallback(
    (option: { featureFlags?: readonly string[] }) =>
      !option.featureFlags || featureEnabled({ and: option.featureFlags }),
    [featureEnabled],
  );

  return (
    <MultiSelectFilter
      isActive={isActive}
      filters={filters}
      handleSetFilter={handleSetFilter}
      handleSetActive={handleSetActive}
      handleToggleFilter={handleToggleFilter}
      filterName={FilterChips.FILE_IMPORT_METHOD}
      filterOptions={FILTER_CONFIG[
        FilterChips.FILE_IMPORT_METHOD
      ].options.filter(filterByFeatureEnabled)}
      label={label}
    />
  );
};

export default FileImportMethodFilter;
